import { UUID } from '../types/uuid';

export const nullUuid: UUID = '00000000-0000-0000-0000-000000000000';
